import { useInkReveal } from "./inked-image";

/**
 * Live Arabic calligraphy (Gulzar, gold gradient) revealed right to left with
 * the same CSS mask slide as InkedImage. Gulzar is subset to the words the site
 * uses: adding a new word means re-subsetting the font (tools/calligraphy).
 */
const InkedText = ({
	children,
	className = "",
	delay = 0,
	duration = 2.2,
	onMount = false,
	play = true,
	decorative = false,
}) => {
	const [ref, inked] = useInkReveal(onMount, play);
	return (
		<span
			ref={ref}
			lang="ar"
			dir="rtl"
			aria-hidden={decorative || undefined}
			className={`ink-reveal gold-ink inline-block font-calligraphy font-normal ${inked ? "is-inked" : ""} ${className}`}
			style={{ "--ink-delay": `${delay}s`, "--ink-duration": `${duration}s` }}
		>
			{children}
		</span>
	);
};

export default InkedText;
